import { useRef } from "react";

import type { PriceCategoryListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { ModuleForm, type ModuleFormHandle } from "Modules/Forms/ModuleForm";
import type { ModuleFormData } from "Modules/Forms/moduleFormSchema";
import { BlModal } from "Shared/Dialogs/BlModal";

interface CreateModuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (data: ModuleFormData) => void;
  priceCategories: PriceCategoryListItemDto[];
  isPriceCategoriesLoading?: boolean;
  serverError?: Error | null;
}

export const CreateModuleModal = ({
  isOpen,
  onClose,
  onConfirm,
  priceCategories,
  isPriceCategoriesLoading,
  serverError,
}: CreateModuleModalProps): React.ReactNode => {
  const { t } = useResource();
  const formRef = useRef<ModuleFormHandle | null>(null);

  const handleClose = () => {
    formRef.current?.reset();
    onClose();
  };

  return (
    <BlModal
      isOpen={isOpen}
      title={t(Resources.Modules.CreateModuleModal.Title)}
      onCancel={handleClose}
      onConfirm={() => formRef.current?.submit(onConfirm)()}
      cancelButtonText={t(Resources.Common.Cancel)}
      confirmButtonText={t(Resources.Modules.CreateModuleModal.Create)}
      maxWidth="800px"
    >
      <ModuleForm
        module={null}
        priceCategories={priceCategories}
        isPriceCategoriesLoading={isPriceCategoriesLoading}
        formRef={formRef}
        serverError={serverError}
      />
    </BlModal>
  );
};
